/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const HelpNeeded = {
    CustomerSuccess: 'CustomerSuccess',
    Marketing: 'Marketing'
};
export function instanceOfHelpNeeded(value) {
    for (const key in HelpNeeded) {
        if (Object.prototype.hasOwnProperty.call(HelpNeeded, key)) {
            if (HelpNeeded[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function HelpNeededFromJSON(json) {
    return HelpNeededFromJSONTyped(json, false);
}
export function HelpNeededFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HelpNeededToJSON(value) {
    return value;
}
export function HelpNeededToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
